
export class CommonConstants {
    public static readonly BaseAddress = process.env.REACT_APP_EXAMS_API;
    public static readonly UserTokenKey = "authenticate_user";

    public static readonly Routes = class {
        public static readonly InstituteDashboard = '/institute/Home';
        public static readonly Home = '/home';
        public static readonly Login = '/';
        public static readonly InstituteProfile = '/institute/Profile';
    }

    public static readonly ApiConstants = class {
        public static readonly Login = '/User/Login';
        public static readonly ForgotPassword = '/User/ForgotPassword';
        public static readonly Register = '/Institution/Register';
        public static readonly InstituteProfile = '/Institution/Profile';
        public static readonly InstitutionsCount = '/Institution/Count';
        public static readonly StudentsCount = '/Student/Count';
        public static readonly InstitutionsAll = '/Institution/All';
        public static readonly StudentsUpload = '/Institution/UploadStudents';
        public static readonly SaveUploadedStudents = '/Institution/SaveStudents';
        public static readonly InstituteStudentCount = '/Institution/StudentsCount';
        public static readonly InstituteGetStudentInfo = '/Institution/GetStudentInfo';
        public static readonly InstitutionListItem = '/Institution/ListItems';
        public static readonly StudentList = '/Student/List';
        public static readonly InstitutionAllStudents = '/Institution/AllStudents';
        public static readonly DomainSettings = '/domain/Settings';

        public static readonly CreateSchool = '/School/Create';
        public static readonly UpdateSchool = '/School/Update';
        public static readonly DeleteMultipleSchools = '/School/DeleteMultiple';
        public static readonly GetSchool = '/School/Get';
        public static readonly ListSchools = '/School/List';
        public static readonly SchoolsSummary = '/School/Summary';

        public static readonly SmsTemplates='/SMS/Templates';
        public static readonly SendSMS='/SMS/Send';

        public static readonly FoundationProgramFileUpload = '/FoundationProgram/File/Upload';
        public static readonly FoundationProgramFiles = '/FoundationProgram/Files';
        public static readonly FoundationProgramDeleteFile = '/FoundationProgram/File/Delete';
        public static readonly FoundationProgramDownloadFile = '/FoundationProgram/File';

        public static readonly OlympiadExamFileUpload = '/OlympiadExam/File/Upload';
        public static readonly OlympiadExamFiles = '/OlympiadExam/Files';
        public static readonly OlympiadExamDeleteFile = '/OlympiadExam/File/Delete';
        public static readonly OlympiadExamDownloadFile = '/OlympiadExam/File';


        public static readonly AbhyasaBharathiFileUpload = '/AbhyasaBharathi/File/Upload';
        public static readonly AbhyasaBharathiFiles = '/AbhyasaBharathi/Files';
        public static readonly AbhyasaBharathiDeleteFile = '/AbhyasaBharathi/File/Delete';
        public static readonly AbhyasaBharathiDownloadFile = '/AbhyasaBharathi/File';

        public static readonly VideoLessionFileUpload = '/VideoLessionFiles/File/Upload';
        public static readonly VideoLessionFiles = '/VideoLessionFiles/Files';
        public static readonly VideoLessionDeleteFile = '/VideoLessionFiles/File/Delete';
        public static readonly VideoLessionDownloadFile = '/VideoLessionFiles/File';


        public static readonly SharedFileUpload = '/SharedlFiles/File/Upload';
        public static readonly EAbhyasSharedFiles = '/SharedlFiles/EAbhyasFiles';
        public static readonly SchoolSharedFiles = '/SharedlFiles/SchoolFiles';
        public static readonly NotificationFiles = '/SharedlFiles/NotificationFiles';
        public static readonly SharedFileDelete = '/SharedlFiles/File/Delete';
        public static readonly SharedFileShare = '/SharedlFiles/File/Share';
        public static readonly SharedFileDownload = '/SharedlFiles/File';


        public static readonly HallTicketList = '/HallTicket/List';
        public static readonly HallTicketFileUpload = '/HallTicket/FileUpload';
        public static readonly HallTicketProcess = '/HallTicket/Process';
        public static readonly HallTicketFileDelete = '/HallTicket/Delete';
        public static readonly HallTicketGenerate = '/HallTicket/Generate';
        public static readonly HallTicketDownloadStudentFile = '/HallTicket/StudentsFile';
        public static readonly HallTicketDownloadHallTicketFile = '/HallTicket/HallTicketsFile';

        public static readonly YoutubeVideos = '/Videos/Latest';

        public static readonly ProgressCardList = '/ProgressCard/List';
        public static readonly ProgressCardFileUpload = '/ProgressCard/FileUpload';
        public static readonly ProgressCardProcess = '/ProgressCard/Process';
        public static readonly ProgressCardFileDelete = '/ProgressCard/Delete';
        public static readonly ProgressCardGenerate = '/ProgressCard/Generate';
        public static readonly ProgressCardDownloadStudentFile = '/ProgressCard/StudentsFile';
        public static readonly ProgressCardDownloadHallTicketFile = '/ProgressCard/ProgressCardFile';

        public static readonly HelpFaqs = '/Help/Faqs';
        public static readonly HelpFaq = (id: number) => `/Help/Faqs/${id}`;
        public static readonly HelpConversations = '/Help/Conversations';
        public static readonly HelpConversation = (id: number) => `/Help/Conversations/${id}`;
        public static readonly HelpMessages = (id: number) => `/Help/Conversations/${id}/Messages`;
        public static readonly HelpCallback = (id: number) => `/Help/Conversations/${id}/Callback`;
        public static readonly HelpResolve = (id: number) => `/Help/Conversations/${id}/Resolve`;

        public static readonly ExamPapers = '/ExamPaper';
        public static readonly ExamPaper = (id: number) => `/ExamPaper/${id}`;
        public static readonly ExamPaperQuestions = (id: number) => `/ExamPaper/${id}/Questions`;
        public static readonly ExamPaperRelease = (id: number) => `/ExamPaper/${id}/Release`;
        public static readonly ExamPaperRetract = (id: number) => `/ExamPaper/${id}/Retract`;
        public static readonly ExamPaperImageUpload = '/ExamPaper/Image';

    }

    public static readonly Constants = class {
        public static readonly cookieKey = "authenticate_user";
        public static readonly cookieExpiry = 5;

    }
    public static readonly UserType = class {
        public static readonly Admin = '1';
        public static readonly School = '2';
    }

}